import React from "react";
import { Box, Container, Grid, Typography, Button, Paper } from "@mui/material";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import SecurityIcon from "@mui/icons-material/Security";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";

const benefits = [
  {
    icon: <CreditCardIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Pagos Seguros",
    description:
      "Recibí pagos con tarjetas de crédito, transferencias y billeteras digitales de manera segura.",
    bgColor: "#565254",
  },
  {
    icon: <SecurityIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Protección Anti-Fraude",
    description:
      "Tus transacciones están protegidas con los más altos estándares de seguridad.",
    bgColor: "#565254",
  },
  {
    icon: <ReceiptLongIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Comprobantes Automáticos",
    description:
      "Generación automática de recibos para cada transacción sin errores.",
    bgColor: "#565254",
  },
  {
    icon: <AccountBalanceWalletIcon sx={{ fontSize: 40, color: "#EE964B" }} />,
    title: "Cobros Anticipados",
    description:
      "Cobranzas seguras y rápidas al confirmar una reserva, sin complicaciones.",
    bgColor: "#565254",
  },
];

function HeroPayments() {
  return (
    <Box
      sx={{
        scrollSnapAlign: "start",
        background: "linear-gradient(0deg, #d2c2f2, #903AF2)",
        height: "100%",
        color: "white",
        py: 8,
        px: 3,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={6} alignItems="center">
          {/* Información principal */}
          <Grid item xs={12} md={6}>
            <Typography
              variant="h3"
              fontWeight="bold"
              gutterBottom
              color={"#fff"}
              sx={{ fontFamily: "'Red Hat Display', sans-serif" }}
            >
              Pagos Online Seguros y Eficientes
            </Typography>
            <Typography
              variant="body1"
              sx={{
                mb: 4,
                fontFamily: "'Merriweather Sans', sans-serif",
                color: "#fff",
              }}
            >
              Recibí pagos de forma segura, rápida y sin complicaciones. Integrá
              pagos con tarjetas, transferencias o billeteras digitales
              directamente desde tu página web o al confirmar una reserva. Ubika
              trabaja con proveedores confiables para que puedas cobrar
              anticipadamente, con comprobantes automáticos y sin errores.
            </Typography>

            <Button
              variant="contained"
              sx={{
                backgroundColor: "#EE964B",
                color: "#ffffff",
                fontWeight: "bold",
                fontFamily: "'Red Hat Display', sans-serif",
                px: 4,
                py: 1.5,
                borderRadius: "12px",
                "&:hover": {
                  backgroundColor: "#d97e3e",
                },
              }}
            >
              Ver Demo
            </Button>
          </Grid>

          {/* Beneficios principales */}
          <Grid item xs={12} md={6}>
            <Grid container spacing={4}>
              {benefits.map((benefit, index) => (
                <Grid item xs={12} sm={6} key={index}>
                  <Paper
                    elevation={3}
                    sx={{
                      p: 3,
                      borderRadius: "12px",
                      backgroundColor: benefit.bgColor,
                      color: "#ffffff",
                      transition: "transform 0.3s ease",
                      "&:hover": {
                        transform: "translateY(-5px)",
                      },
                    }}
                  >
                    {benefit.icon}
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      gutterBottom
                      sx={{ mt: 2 }}
                    >
                      {benefit.title}
                    </Typography>
                    <Typography variant="body2">
                      {benefit.description}
                    </Typography>
                  </Paper>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}

export default HeroPayments;
